<app-navbar *ngIf="insideFocus"></app-navbar>
<app-call-slideup-popover [hidden]="!insideFocus" [allPermission]="allPermission"></app-call-slideup-popover>
<span *ngIf="isLoading && insideFocus" style="display:flex;justify-content:center;height: 100%;align-items: center;">
    <img src="../assets/loader/Loader2.gif" alt="" width="76px" height="76px">
</span>
<router-outlet *ngIf="!isLoading"></router-outlet>